import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export const serviceBundleApiKeyStore = {
  createServiceBundle: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SERVICE_BUNDLE`],
    route: `/ServiceBundle`,
    action: 'POST',
  }),
  deleteServicBundle: (serviceBundeleID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE_BUNDLE`, serviceBundeleID],
    route: `/ServiceBundle/Bundle/${serviceBundeleID}`,
    action: 'DELETE',
  }),
  deleteServicSplitUp: (splitUpID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE_SPLIT_UP`, splitUpID],
    route: `/ServiceBundle/SplitUp/${splitUpID}`,
    action: 'DELETE',
  }),
  deleteServicBundleItem: (BundleItemID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE_BUNDLE_ITEM`, BundleItemID],
    route: `/ServiceBundle/BundleItem/${BundleItemID}`,
    action: 'DELETE',
  }),
  getServiceBundles: (projectID: number): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_BUNDLE`, projectID],
    route: `/ServiceBundle/${projectID}`,
  }),
  getServiceBundleDetails: (serviceBundleID: number): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_BUNDLE_DETAILD`, serviceBundleID],
    route: `/ServiceBundle/Bundle/${serviceBundleID}`,
  }),
  getServices: (projectID: number, officeID: number, unitID: number): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_BUNDLE_SERVICES`, projectID],
    route: `/ServiceBundle/GetServicesForBundle?projectID=${projectID}&officeID=${officeID}&unitID=${unitID}`,
  }),
  getAllServiceBundle: (projectID: number, officeID: number, unitID: number): QueryKeyConfig => ({
    queryKey: [`GET_ALL_SERVICE_BUNDLE `, projectID],
    route: `/ServiceBundle/GetAllServiceBundles?projectID=${projectID}&officeID=${officeID}&unitID=${unitID}`,
  }),
  getSplitItem: (splitupID: number): QueryKeyConfig => ({
    queryKey: [`GET_SPLIT_ITEM `, splitupID],
    route: `/ServiceBundle/GetServiceBundleSplitItems?splitupID=${splitupID}`,
  }),
};
